export default __webpack_public_path__ + "static/media/img-6.80e4393f.jpg";